module.exports = __webpack_public_path__ + "img/logo.3f3f6f61.png";